export default "__VITE_ASSET__$KvNfoNs__";